import { render } from "./ProductPopover.vue?vue&type=template&id=30c2a863"
import script from "./ProductPopover.vue?vue&type=script&lang=js"
export * from "./ProductPopover.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__